var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneRfp, apiUpdateRfpProposal, } from '@/actions/ProfessionalRfpActions';
import { notify } from '@/helpers/action';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useBoolState } from '@/hooks/state/useBoolState';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * コンサルタント：提案意向の更新を行うためのuse
 * @param args
 */
export const useProfessionalRfpProposal = (args) => {
    const { dispatch, id, unmountRef } = args;
    /** 案件データ引き直し */
    const callGetOneRfp = useCallback(() => {
        dispatch(apiGetOneRfp({ path: { id } }, { id }));
    }, [dispatch, id]);
    /** 提案意向をありに更新 */
    const updateProposalTodo = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiUpdateRfpProposal({ json: { proposal: true }, path: { id } }, {}));
        // トースト表示
        notify('提案意向を登録しました');
    }), [dispatch, id]);
    const { callbackPromiseEvent: onClickProposalTodo, doing: loadingProposalTodo, } = usePromiseDoingCallback({
        finallyCallbackFunc: callGetOneRfp,
        promiseEvent: updateProposalTodo,
        unmountRef,
    });
    // 提案辞退モーダルの表示制御
    const { boolState: isShowProposalRefuseModal, changeFalse: hideProposalRefuseModal, changeTrue: showProposalRefuseModal, } = useBoolState();
    /** 提案意向：辞退に更新 */
    const updateProposalRefuse = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        // 閲覧申請を作成
        yield wrapDispatch(dispatch, apiUpdateRfpProposal({ json: Object.assign(Object.assign({}, values), { proposal: false }), path: { id } }, {}));
        // トースト表示
        notify('提案辞退を登録しました');
    }), [dispatch, id]);
    /** 提案意向の辞退後、データの引き直し&モーダルを閉じる */
    const updateProposalRefuseCallback = useCallback(() => {
        callGetOneRfp();
        hideProposalRefuseModal();
    }, [callGetOneRfp, hideProposalRefuseModal]);
    // ローディング制御
    const { callbackPromiseEvent: onSubmitProposalRefuse, doing: loadingProposalRefuse, } = usePromiseDoingCallback({
        finallyCallbackFunc: updateProposalRefuseCallback,
        promiseEvent: updateProposalRefuse,
        unmountRef,
    });
    return {
        hideProposalRefuseModal,
        isShowProposalRefuseModal,
        loadingProposalRefuse,
        loadingProposalTodo,
        onClickProposalTodo,
        onSubmitProposalRefuse,
        showProposalRefuseModal,
    };
};
